import React, { createContext, useState, useEffect, useContext } from 'react';
import keycloak from './keycloak';

const KeycloakContext = createContext();

export const KeycloakProvider = ({ children }) => {
  const [keycloakInitialized, setKeycloakInitialized] = useState(false);
  const [userRoles, setUserRoles] = useState([]);

  useEffect(() => {
    keycloak.init({ onLoad: 'login-required' }).then(authenticated => {
      setKeycloakInitialized(authenticated);
      if (authenticated) {
        const roles = keycloak.tokenParsed?.realm_access?.roles || [];
        setUserRoles(roles);
      }
    }).catch(error => {
      console.error('Failed to initialize Keycloak', error);
    });
  }, []);

  const hasRole = (role) => userRoles.includes(role);

  return (
    <KeycloakContext.Provider value={{ keycloak, keycloakInitialized, hasRole }}>
      {children}
    </KeycloakContext.Provider>
  );
};

export const useKeycloak = () => {
  return useContext(KeycloakContext);
};
